module.exports = "<p>\r\n  dashboard works!\r\n</p>\r\n"